// This is just for convenient access to the em dash character so it does not require Googling to find
const emDash = '—'
export default emDash
